import { youtubeFacts } from "./youtube/youtubeFacts";
const en = {
  // ... UI Translations
    heroBtn: "Start Your Campaign",
    welcome: {
      main: "Multi-Channel Growth",
      highlight: "Simplified.",
    },
    heroSub:
      "From {YT} virality to {WA} and {EM} automation. We deploy 360° marketing strategies that reach your audience wherever they are.",
    solutions: "Solutions",
    socialMediaPerformance: "SocialMedia Performance",
    automationNav: "Automation",
    blogs: "Blogs",
    products: "Products",
    fieldServicePlanner: "Field Service Planner",
    servicesNav: "Services",
    seeAllServices: "See all end-to-end services →",
    searchPlaceholder: "Search...",
    methodology: "Methodology",
    about: "About",
    mydashboard: "My Dashboard",
    points: "p",
    pricingNav: "Pricing",
    logout: "Logout",

    cta: "Book a Strategy Call",
    tagFinder: "Youtube Tag Finder",
    serviceTitle: "Expert Solutions",
    serviceSub:
      "Comprehensive marketing systems designed for the modern creator.",
    servicesListTitle: "Our Services",
    footer: {
      title: "Ready to Scale Your Reach?",
      subtitle:
        "Whether it's WhatsApp automation or YouTube dominance, let's build your Social Flow today.",
      button: "Contact Now",
      columns: {
        platform: "PLATFORM",
        services: "SERVICES",
        useCases: "USE CASES",
        resources: "RESOURCES",
        freeTools: "FREE TOOLS",
        company: "COMPANY",
      },
      platform: {
        socialMediaManager: "Social Media Manager",
        multiAccountManager: "Multi-Account Manager",
        automationTools: "Automation Tools",
        analyticsDashboard: "Analytics Dashboard",
      },
      services: {
        all: "All Services",
        aiAgents: "AI & Agents",
        apiDevelopment: "API Development",
        crmIntegrations: "CRM & Integrations",
        cloudServers: "Cloud & Servers",
      },
      useCases: {
        instagram: "Multiple Instagram Accounts",
        facebook: "Multiple Facebook Accounts",
        bulkEmail: "Bulk Email Campaigns",
        socialAutomation: "Social Media Automation",
      },
      resources: {
        blog: "Blog",
        guides: "Guides",
        apiDocs: "API Docs",
        tutorials: "Tutorials",
      },
      freeTools: {
        smsCalculator: "SMS Cost Calculator",
        emailRoiCalculator: "Email ROI Calculator",
        engagementCalculator: "Engagement Calculator",
      },
      company: {
        pricing: "Pricing",
        about: "About",
        careers: "Careers",
        contact: "Contact",
      },
      privacyPolicy: "Privacy Policy",
      terms: "Terms of Service Agreement",
    },
    tagExtractor: {
      placeholder: "Paste Video URL...",
      findBtn: "Find",
      instruction: "Click on tags to select them, then copy.",
      copyAll: "📋 Copy All",
      copySelected: "Check Selected",
      copySuffix: "& Copy",
      alertAll: "All tags copied!",
      alertSelected: "Selected tags copied!",
      alertNone: "Select some tags first!",
    },
    contact: {
      contact: "Contact",
      title: "Let’s talk about your growth!",
      subtitle:
        "Fill in your details and tell me how I can help you create a winning marketing plan.",
      name: "Your Name",
      email: "Email Address",
      whatsapp: "WhatsApp Number",
      website: "Website URL (Optional)",
      servicePlaceholder: "Select Service of Interest",
      goalsPlaceholder: "Tell me about your business goals...",
      submitBtn: "Get My Free Strategy Call",
      successTitle: "🚀 Message Sent!",
      successSub: "Thank you for reaching out. Reach you shortly.",
      backBtn: "Send another message",
      sidebarTitle: "Contact",
      verify: "Verify",
      sending: "Sending...",
      locationLabel: "Location",
      whatsappLabel: "WhatsApp",
      emailLabel: "Email",
      serviceOptions: [
        "New Feature",
        "SEO Strategy",
        "Paid Ads (Meta/Google)",
        "Content Marketing",
        "1-on-1 Consultation",
      ],
    },
    services: [
      {
        id: 1,
        platform: "YouTube Growth",
        service: "Audience Retention",
        trend: "High ROI",
        description:
          "Turning viewers into subscribers using data-backed SEO, psychological thumbnail design, and content hooks.",
      },
      {
        id: 2,
        platform: "WhatsApp Business",
        service: "Direct Conversions",
        trend: "98% Open Rate",
        description:
          "Personalized automation workflows that engage your customers directly in their favorite messaging app.",
      },
      {
        id: 3,
        platform: "Email Marketing",
        service: "Lifecycle Automation",
        trend: "Scalable",
        description:
          "Building sustainable revenue through sophisticated email funnels, segmentation, and weekly newsletters.",
      },
      {
        id: 4,
        platform: "Social Ecosystem",
        service: "Omnichannel Presence",
        trend: "Viral Potential",
        description:
          "Unified brand voice across Instagram, Facebook, and X (Twitter) to ensure you are everywhere your audience is.",
      },
    ],
    socialPage: {
      heroTitleMain: "Grow Your Brand",
      heroTitleHighlight: "On Social Media",
      heroSubtitle:
        "We help businesses turn content into visibility, engagement, and real inquiries — without wasting time.",
      heroCta: "Start Growing",
      featuredBadge: "FEATURED INTEGRATION",
      featuredHeading: "Unleash Your YouTube Potential",
      featuredIntro:
        "Our SocialFlow suite is deeply integrated with YouTube to help you find the right keywords, track your competition, and understand your audience like never before.",
      card1Title: "Tag Extractor",
      card1Desc:
        "Instantly pull hidden tags and SEO data from any viral video to replicate their success.",
      card1Link: "Try Tag Extractor",
      card2Title: "Deep Analytics",
      card2Desc:
        "Connect your channel to see retention trends, engagement spikes, and growth opportunities.",
      card2Link: "View Dashboard",
      ctaTitle: "Ready to scale your presence?",
      ctaDesc:
        "Join hundreds of creators and businesses using SocialFlow to automate their growth and focus on what they do best: creating.",
      ctaBtn: "Explore Pricing & Plans",
    },
    automatePage: {
      eyebrow: "Automation",
      heroTitle: "Automate Your Business. Scale Without Hiring.",
      heroSubtitle:
        "Smart automation systems that handle leads, follow-ups, sales, and client management — 24/7.",
      heroPrimaryBtn: "Book Free Audit",
      heroSecondaryBtn: "See How It Works",
      servicesHeading: "What You Can Automate",
      servicesSubheading:
        "Pick the busywork you want gone — SocialFlow keeps it running in the background.",
      services: [
        {
          title: "Lead Capture Automation",
          description: "Auto-sync forms, CRM integration, WhatsApp triggers.",
        },
        {
          title: "Email Sequences",
          description: "Welcome flows, abandoned cart, nurture campaigns.",
        },
        {
          title: "Sales Automation",
          description: "Invoices, reminders, payment confirmations.",
        },
        {
          title: "Client Management",
          description: "Onboarding, booking, feedback automation.",
        },
      ],
      processHeading: "How It Works",
      processSubheading:
        "Three simple steps from manual chaos to a business that runs itself.",
      steps: [
        {
          title: "Audit Your Workflow",
          description: "Identify manual tasks and automation opportunities.",
        },
        {
          title: "Build Smart Systems",
          description: "Create funnels, triggers, and CRM integrations.",
        },
        {
          title: "Launch & Optimize",
          description: "Monitor, test, and improve performance.",
        },
      ],
      ctaTitle: "Ready to Stop Doing Everything Manually?",
      ctaSubtitle:
        "Let automation handle the work while you focus on growth.",
      ctaBtn: "Book Strategy Call",
    },
    servicesIndexPage: {
      badge: "End-to-end services",
      heading: "One team for your whole stack",
      intro:
        "Social media is where we start — but we build everything behind it too. AI, apps, websites, integrations, cloud and servers, all from a single partner.",
      cta: "Start a conversation",
      learnMore: "Learn more",
      ctaTitle: "Not sure where to start?",
      ctaSubtitle:
        "Tell us the outcome you want. We will recommend the simplest path to get there.",
      ctaBtn: "Book a Free Consult",
    },
    servicePage: {
      notFoundTitle: "Service not found",
      notFoundText: "The page you are looking for does not exist.",
      backToAll: "Back to all services",
      backHome: "Back to home",
      home: "Home",
      allServices: "All services",
      whatYouGet: "What you get",
      popularUses: "Popular uses",
      talkToSpecialist: "Talk to a specialist",
      exploreMore: "Explore more of what we do",
      scopeTitle: "Let’s scope your {service}",
      scopeSubtitle:
        "Tell us what you need. We will map the fastest, safest path to get it live — free.",
      ctaBtn: "Book a Free Consult",
    },
    pricingPage: {
      heroTitle: "Choose Your Growth Path",
      heroSubtitle: "Pricing That Scales With You",
      heroDesc:
        "Simple pricing. Clear deliverables. Built for creators, freelancers, and growing businesses.",
      mostPopular: "Most Popular",
      getStarted: "Get Started",
      plans: [
        {
          title: "Basic",
          price: "₹4,999 / month",
          features: [
            "8 Posts per month",
            "Facebook / Instagram setup",
            "WhatsApp button integration",
            "Google Business setup",
            "Basic branding guidance",
          ],
        },
        {
          title: "Growth",
          price: "₹9,999 / month",
          features: [
            "15 Posts + 4 Reels",
            "Google Business optimization",
            "Lead capture setup",
            "Review booster system",
            "Basic automation setup",
          ],
        },
        {
          title: "Pro",
          price: "₹19,999 / month",
          features: [
            "Daily content",
            "Response management",
            "Advanced inquiry tracking",
            "Website optimization",
            "Sales follow-up system",
          ],
        },
      ],
      addOnsTitle: "One-Time Add-Ons",
      addOns: [
        { name: "3 Page Website", price: "₹7,500" },
        { name: "5 Page Website", price: "₹12,000" },
        { name: "Digital Catalog Page", price: "₹5,000" },
        { name: "WhatsApp Auto Reply Setup", price: "₹2,500" },
        { name: "Google Review Booster", price: "₹3,500" },
        { name: "Progressive Web App", price: "₹9,999" },
        { name: "Android App", price: "₹25,000" },
      ],
      trust:
        "No hidden charges. Pay 50% upfront and 50% after your project is live.",
    },
    blogPage: {
      seoTitle:
        "SocialFlow Blog | Social Media, Automation & Business Growth Tips",
      title: "Digital Marketing, Social Media & Automation Insights",
      intro:
        "Explore expert guides on social media growth, automation tools, business strategies, and productivity. Learn how to scale faster using smarter systems.",
      searchPlaceholder: "Search blogs...",
      featured: "Featured",
      categories: [
        { value: "All", label: "All" },
        { value: "Social Media", label: "Social Media" },
        { value: "Automation", label: "Automation" },
        { value: "Growth", label: "Growth" },
        { value: "Business", label: "Business" },
        { value: "AI", label: "AI" },
      ],
    },
    aboutPage: {
      heroTitleLead: "Bridging the gap between",
      heroTitleHighlight: "Creativity & Automation",
      heroSub:
        "SocialFlow was founded in New Delhi with a single mission: To replace manual social media guesswork with algorithmic precision.",
      whyTitle: "Why we built SocialFlow",
      whyP1:
        "The digital landscape is moving too fast for traditional manual management. We realized that creators and businesses were spending 80% of their time on technical chores—finding tags, optimizing SEO, and tracking metrics—and only 20% on their actual craft.",
      whyP2Before: "We built our proprietary toolset, including our",
      whyP2Strong: "YouTube Tag Extractor",
      whyP2After:
        ", to flip that ratio. We handle the data; you handle the vision.",
      dataDrivenGrowth: "Data-Driven Growth",
      methodologyTitle: "Our 3-Pillar Methodology",
      pillars: [
        {
          title: "The Deep Audit",
          text: "We don't guess. We use metadata analysis to understand why your competitors are winning and where the \"open lanes\" are for your brand.",
        },
        {
          title: "Algorithmic SEO",
          text: "Every post and video is optimized using our custom tools to ensure the platform algorithms work for you, not against you.",
        },
        {
          title: "Human Oversight",
          text: "Technology is our platform, but humans are the drivers. Every automated insight is vetted by our Delhi-based strategy team.",
        },
      ],
      ctaTitle: "Ready to automate your growth?",
      ctaButton: "Partner With Us",
    },
    dashboard: {
      sidebarTitle: "Dashboard",
      soon: "Soon",
      welcome: "Welcome to SocialFlow",
    },
    comingSoon: {
      featureNameDefault: "This Feature",
      description:
        "We're working hard to bring you this experience. Join the waitlist to be first to know when it goes live.",
      badge: "Coming Soon",
      titleTemplate: "{feature} is on its way!",
      emailPlaceholder: "Enter your email",
      notifyBtn: "Notify Me",
      built: "Built",
      inWaitlist: "In Waitlist",
    },
    userProfile: {
      title: "My Profile",
      personalInfo: "Personal Info",
      phone: "Phone",
      address: "Address",
      companyInfo: "Company Info",
      companyName: "Company Name",
      companyAddress: "Company Address",
      save: "Save",
      requiredAlert: "Phone and Company Name are required.",
      savedAlert: "Profile saved successfully!",
    },
    pointsHistory: {
      accessDenied: "Access Denied",
      accessDeniedBody:
        "Please log in to view your points and transaction history.",
      transactionHistory: "Transaction History",
      sixMonths: "6 Months",
      all: "All",
      noTransactions: "No transactions found yet.",
      invalidAmountAlert: "Please enter a valid positive amount.",
      manualTopUp: "Manual Top Up",
      addedAlert: "Successfully added {amount} points!",
      addFailedAlert: "Failed to add points. Please try again.",
      currentBalance: "Current Balance",
      socialPoints: "SocialPoints",
      valueApprox: "Value: approx. ₹{amount} in platform services",
      topUp: "Top Up",
      topUpBody:
        "During our Beta phase, you can manually top up points to access premium tools.",
      add: "Add",
      howToUse: "How to Use Points",
      usageItems: [
        { title: "Email Verification", cost: "5 pts / 100 emails" },
        { title: "Advanced YT Reports", cost: "10 pts / report" },
        { title: "Automation Rules", cost: "2 pts / active rule" },
        { title: "Template Generation", cost: "1 pt / AI generation" },
      ],
      footerNote:
        "Points never expire. You can earn free points daily by verifying your profile or engaging with our newsletter.",
      at: "at",
    },
    fieldServicePlannerPage: {
      heroTitleLead: "Master Your",
      heroTitleHighlight: "Field Operations",
      heroBody:
        "Streamline scheduling, dispatching, and on-site service operations with our intelligent planning system designed to eliminate manual errors and boost productivity.",
      getStarted: "Get Started Free",
      bookDemo: "Book a Demo",
      features: [
        {
          title: "Smart Scheduling",
          description:
            "Automatically assign jobs based on availability with intelligent conflict detection.",
        },
        {
          title: "Technician Dispatch",
          description:
            "Assign jobs based on location and skillset with route optimization.",
        },
        {
          title: "Live Tracking",
          description:
            "Track technicians in real-time and monitor job progress with instant updates.",
        },
        {
          title: "Job Management",
          description:
            "Create, edit, and manage service requests with a complete digital history.",
        },
        {
          title: "Analytics & Reports",
          description:
            "Gain deep insights into performance, productivity, and completion rates.",
        },
        {
          title: "Verified Workflow",
          description:
            "Standardized processes ensure every job meets your quality benchmarks.",
        },
      ],
      processTitleLead: "A Three-Step Workflow for",
      processHighlight: "Peak Efficiency",
      steps: [
        {
          step: "01",
          title: "Smart Ingest",
          desc: "Incoming requests are automatically parsed and ranked by priority and location.",
        },
        {
          step: "02",
          title: "Skill-Based Dispatch",
          desc: "Our algorithm matches the right technician with the right job based on expertise.",
        },
        {
          step: "03",
          title: "Real-time Verification",
          desc: "On-site photos and digital signatures ensure every job is completed to standard.",
        },
      ],
      whyChooseTitle: "Why Businesses Choose Us",
      benefits: [
        "Reduce operational costs by up to 25%",
        "Improve customer satisfaction scores",
        "Eliminate paperwork and manual data entry",
        "Scale your field operations with confidence",
      ],
      audienceTitle: "Perfect For Modern Service Teams",
      audiences: [
        "IT Support & Repair",
        "Home Maintenance",
        "Consulting Services",
        "Delivery Logistics",
        "Health & Home Care",
      ],
    },
    // --- YOUTUBE INSIGHTS DATA (EN) ---
    youtubeFacts: youtubeFacts.en,
};

export const translations = {
  en,
  hi: {
    // ... UI Translations (Hindi)
    heroBtn: "अपना अभियान शुरू करें",
    welcome: {
      main: "मल्टी-चैनल ग्रोथ",
      highlight: "अब हुई आसान।",
    },
    heroSub:
      "{YT} की लोकप्रियता से लेकर {WA} और {EM} ऑटोमेशन तक। हम 360° मार्केटिंग रणनीतियां तैनात करते हैं जो आपके दर्शकों तक पहुंचती हैं।",
    solutions: "समाधान",
    socialMediaPerformance: "सोशल मीडिया प्रदर्शन",
    automationNav: "ऑटोमेशन",
    blogs: "ब्लॉग्स",
    products: "उत्पाद",
    fieldServicePlanner: "फील्ड सर्विस प्लानर",
    servicesNav: "सेवाएं",
    seeAllServices: "सभी एंड-टू-एंड सेवाएं देखें →",
    searchPlaceholder: "खोजें...",
    methodology: "कार्यप्रणाली",
    about: "बारे में",
    mydashboard: "मेरा डैशबोर्ड",
    points: "पॉ",
    pricingNav: "प्राइसिंग",
    logout: "लॉग आउट",

    cta: "रणनीति कॉल बुक करें",
    tagFinder: "वीडियो टैग खोजक",
    serviceTitle: "विशेषज्ञ समाधान",
    serviceSub: "आधुनिक रचनाकारों के लिए डिज़ाइन की गई मार्केटिंग प्रणाली।",
    servicesListTitle: "हमारी सेवाएं",
    footer: {
      title: "अपनी पहुंच बढ़ाने के लिए तैयार हैं?",
      subtitle:
        "चाहे व्हाट्सएप ऑटोमेशन हो या यूट्यूब डोमिनेंस, आइए आज आपका SocialFlow बनाएं।",
      button: "अभी शुरू करें",
      columns: {
        platform: "प्लेटफ़ॉर्म",
        services: "सेवाएं",
        useCases: "उपयोग के मामले",
        resources: "संसाधन",
        freeTools: "मुफ़्त टूल्स",
        company: "कंपनी",
      },
      platform: {
        socialMediaManager: "सोशल मीडिया मैनेजर",
        multiAccountManager: "मल्टी-अकाउंट मैनेजर",
        automationTools: "ऑटोमेशन टूल्स",
        analyticsDashboard: "एनालिटिक्स डैशबोर्ड",
      },
      services: {
        all: "सभी सेवाएं",
        aiAgents: "AI और एजेंट्स",
        apiDevelopment: "API डेवलपमेंट",
        crmIntegrations: "CRM और इंटीग्रेशन",
        cloudServers: "क्लाउड और सर्वर",
      },
      useCases: {
        instagram: "कई इंस्टाग्राम अकाउंट्स",
        facebook: "कई फेसबुक अकाउंट्स",
        bulkEmail: "बल्क ईमेल कैंपेन",
        socialAutomation: "सोशल मीडिया ऑटोमेशन",
      },
      resources: {
        blog: "ब्लॉग",
        guides: "गाइड्स",
        apiDocs: "API डॉक्स",
        tutorials: "ट्यूटोरियल्स",
      },
      freeTools: {
        smsCalculator: "SMS कॉस्ट कैलकुलेटर",
        emailRoiCalculator: "ईमेल ROI कैलकुलेटर",
        engagementCalculator: "एंगेजमेंट कैलकुलेटर",
      },
      company: {
        pricing: "प्राइसिंग",
        about: "बारे में",
        careers: "करियर",
        contact: "संपर्क",
      },
      privacyPolicy: "प्राइवेसी पॉलिसी",
      terms: "सेवा की शर्तें समझौता",
    },
    tagExtractor: {
      placeholder: "वीडियो URL पेस्ट करें...",
      findBtn: "खोजें",
      instruction: "टैग चुनने के लिए उन पर क्लिक करें, फिर कॉपी करें।",
      copyAll: "📋 सभी कॉपी करें",
      copySelected: "चुने हुए चेक करें",
      copySuffix: "और कॉपी करें",
      alertAll: "सभी टैग कॉपी हो गए!",
      alertSelected: "चुने हुए टैग कॉपी हो गए!",
      alertNone: "पहले कुछ टैग चुनें!",
    },
    contact: {
      contact: "संपर्क",
      title: "चलिए आपके बिज़नेस की ग्रोथ पर बात करते हैं!",
      subtitle:
        "अपनी डिटेल्स भरें और मुझे बताएं कि मैं एक बेहतरीन मार्केटिंग प्लान बनाने में आपकी कैसे मदद कर सकता हूँ।",
      name: "आपका नाम",
      email: "ईमेल पता",
      whatsapp: "व्हाट्सएप नंबर",
      website: "वेबसाइट URL (वैकल्पिक)",
      servicePlaceholder: "अपनी पसंद की सर्विस चुनें",
      goalsPlaceholder: "अपने बिज़नेस गोल्स के बारे में बताएं...",
      submitBtn: "मेरी फ्री स्ट्रेटेजी कॉल बुक करें",
      successTitle: "🚀 संदेश भेज दिया गया है!",
      successSub:
        "संपर्क करने के लिए धन्यवाद। हेमंत जल्द ही आपसे संपर्क करेंगे।",
      backBtn: "दूसरा संदेश भेजें",
      sidebarTitle: "संपर्क",
      verify: "सत्यापित करें",
      sending: "भेजा जा रहा है...",
      locationLabel: "स्थान",
      whatsappLabel: "व्हाट्सएप",
      emailLabel: "ईमेल",
      serviceOptions: [
        "नई सुविधा",
        "SEO रणनीति",
        "पेड ऐड्स (Meta/Google)",
        "कंटेंट मार्केटिंग",
        "1-से-1 परामर्श",
      ],
    },
    services: [
      {
        id: 1,
        platform: "यूट्यूब ग्रोथ",
        service: "दर्शक प्रतिधारण",
        trend: "High ROI",
        description: "दर्शकों को सब्सक्राइबर्स में बदलना।",
      },
      {
        id: 2,
        platform: "व्हाट्सएप बिजनेस",
        service: "प्रत्यक्ष रूपांतरण",
        trend: "98% ओपन रेट",
        description:
          "व्यक्तिगत ऑटोमेशन वर्कफ़्लो जो आपके ग्राहकों को सीधे जोड़ते हैं।",
      },
      {
        id: 3,
        platform: "ईमेल मार्केटिंग",
        service: "लाइफसाइकिल ऑटोమेशन",
        trend: "स्केलेबल",
        description:
          "परिष्कृत ईमेल फ़नल और न्यूज़लेटर्स के माध्यम से स्थायी राजस्व बनाना।",
      },
      {
        id: 4,
        platform: "सोशल इकोसिस्टम",
        service: "ओमनीचैनल उपस्थिति",
        trend: "वायरल क्षमता",
        description:
          "इंस्टाग्राम, फेसबुक और एक्स (ट्विटर) पर एकीकृत ब्रांड आवाज।",
      },
    ],
    socialPage: {
      heroTitleMain: "अपना ब्रांड बढ़ाएं",
      heroTitleHighlight: "सोशल मीडिया पर",
      heroSubtitle:
        "हम बिज़नेस को कंटेंट से विज़िबिलिटी, एंगेजमेंट और असली पूछताछ में बदलने में मदद करते हैं — बिना समय बर्बाद किए।",
      heroCta: "ग्रो करना शुरू करें",
      featuredBadge: "फ़ीचर्ड इंटीग्रेशन",
      featuredHeading: "अपनी YouTube क्षमता का पूरा उपयोग करें",
      featuredIntro:
        "हमारा SocialFlow सूट YouTube के साथ गहराई से जुड़ा है ताकि आप सही कीवर्ड खोज सकें, अपने प्रतिस्पर्धियों पर नज़र रख सकें और अपने दर्शकों को पहले से बेहतर समझ सकें।",
      card1Title: "टैग एक्सट्रैक्टर",
      card1Desc:
        "किसी भी वायरल वीडियो से छिपे टैग और SEO डेटा तुरंत निकालें और उनकी सफलता दोहराएं।",
      card1Link: "टैग एक्सट्रैक्टर आज़माएं",
      card2Title: "गहरा एनालिटिक्स",
      card2Desc:
        "अपना चैनल जोड़ें और रिटेंशन ट्रेंड्स, एंगेजमेंट स्पाइक्स और ग्रोथ के अवसर देखें।",
      card2Link: "डैशबोर्ड देखें",
      ctaTitle: "अपनी मौजूदगी बढ़ाने के लिए तैयार हैं?",
      ctaDesc:
        "सैकड़ों क्रिएटर्स और बिज़नेस SocialFlow के साथ अपनी ग्रोथ ऑटोमेट कर रहे हैं और अपना सबसे अच्छा काम—क्रिएशन—पर ध्यान दे रहे हैं।",
      ctaBtn: "प्राइसिंग और प्लान देखें",
    },
    automatePage: {
      eyebrow: "ऑटोमेशन",
      heroTitle: "अपना बिज़नेस ऑटोमेट करें। बिना भर्ती किए बढ़ें।",
      heroSubtitle:
        "स्मार्ट ऑटोमेशन सिस्टम जो लीड्स, फॉलो-अप, सेल्स और क्लाइंट मैनेजमेंट — 24/7 संभालते हैं।",
      heroPrimaryBtn: "फ्री ऑडिट बुक करें",
      heroSecondaryBtn: "देखें यह कैसे काम करता है",
      servicesHeading: "आप क्या-क्या ऑटोमेट कर सकते हैं",
      servicesSubheading:
        "जो झंझट आप हटाना चाहते हैं उसे चुनें — SocialFlow उसे बैकग्राउंड में चलाता रहता है।",
      services: [
        {
          title: "लीड कैप्चर ऑटोमेशन",
          description: "फॉर्म ऑटो-सिंक, CRM इंटीग्रेशन, व्हाट्सएप ट्रिगर्स।",
        },
        {
          title: "ईमेल सीक्वेंस",
          description: "वेलकम फ़्लो, एबैंडन कार्ट, नर्चर कैंपेन।",
        },
        {
          title: "सेल्स ऑटोमेशन",
          description: "इनवॉइस, रिमाइंडर, पेमेंट कन्फर्मेशन।",
        },
        {
          title: "क्लाइंट मैनेजमेंट",
          description: "ऑनबोर्डिंग, बुकिंग, फीडबैक ऑटोमेशन।",
        },
      ],
      processHeading: "यह कैसे काम करता है",
      processSubheading:
        "मैन्युअल भागदौड़ से लेकर खुद चलने वाले बिज़नेस तक तीन आसान कदम।",
      steps: [
        {
          title: "अपना वर्कफ़्लो ऑडिट करें",
          description:
            "मैन्युअल कामों और ऑटोमेशन के अवसरों की पहचान करें।",
        },
        {
          title: "स्मार्ट सिस्टम बनाएं",
          description: "फ़नल, ट्रिगर्स और CRM इंटीग्रेशन बनाएं।",
        },
        {
          title: "लॉन्च और ऑप्टिमाइज़ करें",
          description: "परफ़ॉर्मेंस की निगरानी करें, टेस्ट करें और सुधारें।",
        },
      ],
      ctaTitle: "सब कुछ मैन्युअली करना बंद करने के लिए तैयार हैं?",
      ctaSubtitle: "काम ऑटोमेशन संभाले और आप ग्रोथ पर ध्यान दें।",
      ctaBtn: "रणनीति कॉल बुक करें",
    },
    servicesIndexPage: {
      badge: "एंड-टू-एंड सेवाएं",
      heading: "आपके पूरे टेक स्टैक के लिए एक टीम",
      intro:
        "सोशल मीडिया हमारी शुरुआत है — लेकिन हम उसके पीछे का सब कुछ भी बनाते हैं। AI, ऐप्स, वेबसाइट्स, इंटीग्रेशन, क्लाउड और सर्वर, सब एक ही पार्टनर से।",
      cta: "बातचीत शुरू करें",
      learnMore: "और जानें",
      ctaTitle: "समझ नहीं आ रहा कहाँ से शुरू करें?",
      ctaSubtitle:
        "बताएं आप क्या नतीजा चाहते हैं। हम वहां पहुंचने का सबसे आसान रास्ता सुझाएंगे।",
      ctaBtn: "फ्री कंसल्ट बुक करें",
    },
    servicePage: {
      notFoundTitle: "सेवा नहीं मिली",
      notFoundText: "आप जो पेज खोज रहे हैं वह मौजूद नहीं है।",
      backToAll: "सभी सेवाओं पर वापस जाएं",
      backHome: "होम पर वापस",
      home: "होम",
      allServices: "सभी सेवाएं",
      whatYouGet: "आपको क्या मिलता है",
      popularUses: "लोकप्रिय उपयोग",
      talkToSpecialist: "विशेषज्ञ से बात करें",
      exploreMore: "हम और क्या करते हैं, यह देखें",
      scopeTitle: "आइए आपकी {service} की योजना बनाएं",
      scopeSubtitle:
        "बताएं आपको क्या चाहिए। हम इसे लाइव करने का सबसे तेज़ और सुरक्षित रास्ता बनाएंगे — बिल्कुल फ्री।",
      ctaBtn: "फ्री कंसल्ट बुक करें",
    },
    pricingPage: {
      heroTitle: "अपना ग्रोथ पाथ चुनें",
      heroSubtitle: "ऐसी प्राइसिंग जो आपके साथ बढ़े",
      heroDesc:
        "आसान प्राइसिंग। स्पष्ट डिलीवरेबल्स। क्रिएटर्स, फ्रीलांसर्स और बढ़ते बिज़नेस के लिए बनाई गई।",
      mostPopular: "सबसे लोकप्रिय",
      getStarted: "शुरू करें",
      plans: [
        {
          title: "बेसिक",
          price: "₹4,999 / महीना",
          features: [
            "हर महीने 8 पोस्ट",
            "फेसबुक / इंस्टाग्राम सेटअप",
            "व्हाट्सएप बटन इंटीग्रेशन",
            "Google बिज़नेस सेटअप",
            "बेसिक ब्रांडिंग मार्गदर्शन",
          ],
        },
        {
          title: "ग्रोथ",
          price: "₹9,999 / महीना",
          features: [
            "15 पोस्ट + 4 रील्स",
            "Google बिज़नेस ऑप्टिमाइज़ेशन",
            "लीड कैप्चर सेटअप",
            "रिव्यू बूस्टर सिस्टम",
            "बेसिक ऑटोमेशन सेटअप",
          ],
        },
        {
          title: "प्रो",
          price: "₹19,999 / महीना",
          features: [
            "रोज़ का कंटेंट",
            "रिस्पॉन्स मैनेजमेंट",
            "एडवांस्ड इंक्वायरी ट्रैकिंग",
            "वेबसाइट ऑप्टिमाइज़ेशन",
            "सेल्स फॉलो-अप सिस्टम",
          ],
        },
      ],
      addOnsTitle: "वन-टाइम ऐड-ऑन्स",
      addOns: [
        { name: "3 पेज वेबसाइट", price: "₹7,500" },
        { name: "5 पेज वेबसाइट", price: "₹12,000" },
        { name: "डिजिटल कैटलॉग पेज", price: "₹5,000" },
        { name: "व्हाट्सएप ऑटो रिप्लाई सेटअप", price: "₹2,500" },
        { name: "Google रिव्यू बूस्टर", price: "₹3,500" },
        { name: "प्रोग्रेसिव वेब ऐप", price: "₹9,999" },
        { name: "एंड्रॉइड ऐप", price: "₹25,000" },
      ],
      trust:
        "कोई छिपा शुल्क नहीं। 50% पहले और 50% आपका प्रोजेक्ट लाइव होने के बाद दें।",
    },
    blogPage: {
      seoTitle:
        "SocialFlow ब्लॉग | सोशल मीडिया, ऑटोमेशन और बिज़नेस ग्रोथ टिप्स",
      title: "डिजिटल मार्केटिंग, सोशल मीडिया और ऑटोमेशन इनसाइट्स",
      intro:
        "सोशल मीडिया ग्रोथ, ऑटोमेशन टूल्स, बिज़नेस रणनीतियों और उत्पादकता पर विशेषज्ञ गाइड पढ़ें। समझें कि स्मार्ट सिस्टम्स से तेज़ी से कैसे स्केल करें।",
      searchPlaceholder: "ब्लॉग खोजें...",
      featured: "फ़ीचर्ड",
      categories: [
        { value: "All", label: "सभी" },
        { value: "Social Media", label: "सोशल मीडिया" },
        { value: "Automation", label: "ऑटोमेशन" },
        { value: "Growth", label: "ग्रोथ" },
        { value: "Business", label: "बिज़नेस" },
        { value: "AI", label: "AI" },
      ],
    },
    aboutPage: {
      heroTitleLead: "जोड़ें",
      heroTitleHighlight: "रचनात्मकता और ऑटोमेशन को",
      heroSub:
        "SocialFlow की स्थापना नई दिल्ली में एक ही मिशन के साथ हुई: मैनुअल सोशल मीडिया अंदाज़े को एल्गोरिदमिक सटीकता से बदलना।",
      whyTitle: "हमने SocialFlow क्यों बनाया",
      whyP1:
        "डिजिटल परिदृश्य पारंपरिक मैनुअल प्रबंधन के लिए बहुत तेज़ी से बदल रहा है। हमने पाया कि क्रिएटर और बिज़नेस अपना 80% समय तकनीकी कामों—टैग खोजने, SEO ऑप्टिमाइज़ करने और मेट्रिक्स ट्रैक करने—में बिता रहे थे, और केवल 20% अपने वास्तविक काम पर।",
      whyP2Before: "हमने अपना प्रोप्राइटरी टूलसेट बनाया, जिसमें हमारा",
      whyP2Strong: "YouTube टैग एक्सट्रैक्टर",
      whyP2After:
        " भी शामिल है, ताकि यह अनुपात पलट जाए। डेटा हम संभालते हैं; दृष्टि आप संभालते हैं।",
      dataDrivenGrowth: "डेटा-संचालित विकास",
      methodologyTitle: "हमारी 3-स्तंभ कार्यप्रणाली",
      pillars: [
        {
          title: "गहरा ऑडिट",
          text: "हम अंदाज़ा नहीं लगाते। हम मेटाडेटा विश्लेषण का उपयोग यह समझने के लिए करते हैं कि आपके प्रतिस्पर्धी क्यों जीत रहे हैं और आपके ब्रांड के लिए 'खुली राहें' कहाँ हैं।",
        },
        {
          title: "एल्गोरिदमिक SEO",
          text: "हर पोस्ट और वीडियो को हमारे कस्टम टूल्स से ऑप्टिमाइज़ किया जाता है ताकि प्लेटफ़ॉर्म एल्गोरिदम आपके पक्ष में काम करें, विरोध में नहीं।",
        },
        {
          title: "मानवीय निगरानी",
          text: "तकनीक हमारा प्लेटफ़ॉर्म है, लेकिन मानव चालक हैं। हर स्वचालित इनसाइट को हमारी दिल्ली-आधारित रणनीति टीम जाँचती है।",
        },
      ],
      ctaTitle: "अपनी ग्रोथ ऑटोमेट करने के लिए तैयार हैं?",
      ctaButton: "हमसे जुड़ें",
    },
    dashboard: {
      sidebarTitle: "डैशबोर्ड",
      soon: "जल्द आ रहा है",
      welcome: "SocialFlow में आपका स्वागत है",
    },
    comingSoon: {
      featureNameDefault: "यह सुविधा",
      description:
        "हम इस अनुभव को लाने के लिए कड़ी मेहनत कर रहे हैं। लाइव होने पर सबसे पहले जानने के लिए वेटलिस्ट में शामिल हों।",
      badge: "जल्द आ रहा है",
      titleTemplate: "{feature} जल्द आ रहा है!",
      emailPlaceholder: "अपना ईमेल दर्ज करें",
      notifyBtn: "मुझे सूचित करें",
      built: "तैयार",
      inWaitlist: "वेटलिस्ट में",
    },
    userProfile: {
      title: "मेरी प्रोफ़ाइल",
      personalInfo: "व्यक्तिगत जानकारी",
      phone: "फ़ोन",
      address: "पता",
      companyInfo: "कंपनी जानकारी",
      companyName: "कंपनी का नाम",
      companyAddress: "कंपनी का पता",
      save: "सहेजें",
      requiredAlert: "फ़ोन और कंपनी का नाम आवश्यक हैं।",
      savedAlert: "प्रोफ़ाइल सफलतापूर्वक सहेजी गई!",
    },
    pointsHistory: {
      accessDenied: "पहुंच अस्वीकृत",
      accessDeniedBody:
        "अपने पॉइंट्स और लेन-देन का इतिहास देखने के लिए कृपया लॉग इन करें।",
      transactionHistory: "लेन-देन का इतिहास",
      sixMonths: "6 महीने",
      all: "सभी",
      noTransactions: "अभी तक कोई लेन-देन नहीं मिला।",
      invalidAmountAlert: "कृपया एक मान्य धनात्मक राशि दर्ज करें।",
      manualTopUp: "मैनुअल टॉप अप",
      addedAlert: "सफलतापूर्वक {amount} पॉइंट्स जोड़े गए!",
      addFailedAlert: "पॉइंट्स जोड़ने में विफल। कृपया पुनः प्रयास करें।",
      currentBalance: "वर्तमान शेष",
      socialPoints: "SocialPoints",
      valueApprox: "मूल्य: लगभग ₹{amount} प्लेटफ़ॉर्म सेवाओं में",
      topUp: "टॉप अप",
      topUpBody:
        "हमारे बीटा चरण के दौरान, आप प्रीमियम टूल्स तक पहुंचने के लिए मैन्युअल रूप से पॉइंट्स टॉप अप कर सकते हैं।",
      add: "जोड़ें",
      howToUse: "पॉइंट्स का उपयोग कैसे करें",
      usageItems: [
        { title: "ईमेल सत्यापन", cost: "5 पॉइंट्स / 100 ईमेल" },
        { title: "उन्नत YT रिपोर्ट्स", cost: "10 पॉइंट्स / रिपोर्ट" },
        { title: "ऑटोमेशन नियम", cost: "2 पॉइंट्स / सक्रिय नियम" },
        { title: "टेम्पलेट जनरेशन", cost: "1 पॉइंट / AI जनरेशन" },
      ],
      footerNote:
        "पॉइंट्स कभी समाप्त नहीं होते। आप अपनी प्रोफ़ाइल सत्यापित करके या हमारे न्यूज़लेटर से जुड़कर रोज़ मुफ़्त पॉइंट्स कमा सकते हैं।",
      at: "को",
    },
    fieldServicePlannerPage: {
      heroTitleLead: "अपने",
      heroTitleHighlight: "फील्ड ऑपरेशंस",
      heroBody:
        "शेड्यूलिंग, डिस्पैचिंग और ऑन-साइट सेवा संचालन को हमारे बुद्धिमान प्लानिंग सिस्टम के साथ सुव्यवस्थित करें, जो मैनुअल त्रुटियों को खत्म करने और उत्पादकता बढ़ाने के लिए डिज़ाइन किया गया है।",
      getStarted: "मुफ़्त शुरू करें",
      bookDemo: "डेमो बुक करें",
      features: [
        {
          title: "स्मार्ट शेड्यूलिंग",
          description:
            "बुद्धिमान कॉन्फ्लिक्ट डिटेक्शन के साथ उपलब्धता के आधार पर काम स्वचालित रूप से असाइन करें।",
        },
        {
          title: "तकनीशियन डिस्पैच",
          description:
            "रूट ऑप्टिमाइज़ेशन के साथ स्थान और कौशल के आधार पर काम असाइन करें।",
        },
        {
          title: "लाइव ट्रैकिंग",
          description:
            "तकनीशियनों को रीयल-टाइम में ट्रैक करें और तत्काल अपडेट के साथ काम की प्रगति देखें।",
        },
        {
          title: "जॉब मैनेजमेंट",
          description:
            "पूर्ण डिजिटल इतिहास के साथ सेवा अनुरोध बनाएं, संपादित करें और प्रबंधित करें।",
        },
        {
          title: "एनालिटिक्स और रिपोर्ट्स",
          description:
            "प्रदर्शन, उत्पादकता और पूर्णता दरों में गहरी जानकारी प्राप्त करें।",
        },
        {
          title: "सत्यापित वर्कफ़्लो",
          description:
            "मानकीकृत प्रक्रियाएं सुनिश्चित करती हैं कि हर काम आपके गुणवत्ता मानकों को पूरा करे।",
        },
      ],
      processTitleLead: "तीन-चरणीय वर्कफ़्लो,",
      processHighlight: "उच्चतम दक्षता के लिए",
      steps: [
        {
          step: "01",
          title: "स्मार्ट इनजेस्ट",
          desc: "आने वाले अनुरोध स्वचालित रूप से प्राथमिकता और स्थान के अनुसार पार्स और रैंक किए जाते हैं।",
        },
        {
          step: "02",
          title: "कौशल-आधारित डिस्पैच",
          desc: "हमारा एल्गोरिदम विशेषज्ञता के आधार पर सही तकनीशियन को सही काम से जोड़ता है।",
        },
        {
          step: "03",
          title: "रीयल-टाइम सत्यापन",
          desc: "ऑन-साइट फ़ोटो और डिजिटल हस्ताक्षर सुनिश्चित करते हैं कि हर काम मानक के अनुसार पूरा हो।",
        },
      ],
      whyChooseTitle: "बिज़नेस हमें क्यों चुनते हैं",
      benefits: [
        "परिचालन लागत 25% तक कम करें",
        "ग्राहक संतुष्टि स्कोर बेहतर करें",
        "कागज़ी कार्रवाई और मैनुअल डेटा एंट्री खत्म करें",
        "आत्मविश्वास के साथ अपने फील्ड ऑपरेशंस स्केल करें",
      ],
      audienceTitle: "आधुनिक सेवा टीमों के लिए बिल्कुल सही",
      audiences: [
        "IT सपोर्ट और रिपेयर",
        "होम मेंटेनेंस",
        "कंसल्टिंग सेवाएं",
        "डिलीवरी लॉजिस्टिक्स",
        "हेल्थ और होम केयर",
      ],
    },
    // --- YOUTUBE INSIGHTS DATA (HI) ---
    youtubeFacts: youtubeFacts.hi,
  },
  fr: {
    ...en,
    heroBtn: "Lancez votre campagne",
    welcome: {
      ...en.welcome,
      main: "Croissance multicanale",
      highlight: "Simplifiée.",
    },
    heroSub:
      "De la viralité {YT} à l'automatisation {WA} et {EM}. Nous déployons des stratégies marketing à 360° qui atteignent votre audience où qu'elle soit.",
    solutions: "Solutions",
    socialMediaPerformance: "Performance SocialMedia",
    automationNav: "Automatisation",
    blogs: "Blogs",
    products: "Produits",
    fieldServicePlanner: "Planificateur d'interventions",
    servicesNav: "Services",
    seeAllServices: "Voir tous les services de bout en bout →",
    searchPlaceholder: "Rechercher...",
    methodology: "Méthodologie",
    about: "À propos",
    mydashboard: "Mon tableau de bord",
    points: "p",
    pricingNav: "Tarifs",
    logout: "Déconnexion",

    cta: "Réserver un appel stratégique",
    tagFinder: "Recherche de tags YouTube",
    serviceTitle: "Solutions expertes",
    serviceSub:
      "Des systèmes marketing complets conçus pour le créateur moderne.",
    servicesListTitle: "Nos services",
    footer: {
      ...en.footer,
      title: "Prêt à amplifier votre portée ?",
      subtitle:
        "Qu'il s'agisse d'automatisation WhatsApp ou de domination YouTube, construisons votre Social Flow dès aujourd'hui.",
      button: "Contactez maintenant",
      columns: {
        ...en.footer.columns,
        platform: "PLATEFORME",
        services: "SERVICES",
        useCases: "CAS D'USAGE",
        resources: "RESSOURCES",
        freeTools: "OUTILS GRATUITS",
        company: "ENTREPRISE",
      },
      platform: {
        ...en.footer.platform,
        socialMediaManager: "Gestionnaire de réseaux sociaux",
        multiAccountManager: "Gestionnaire multi-comptes",
        automationTools: "Outils d'automatisation",
        analyticsDashboard: "Tableau de bord analytique",
      },
      services: {
        ...en.footer.services,
        all: "Tous les services",
        aiAgents: "IA et agents",
        apiDevelopment: "Développement d'API",
        crmIntegrations: "CRM et intégrations",
        cloudServers: "Cloud et serveurs",
      },
      useCases: {
        ...en.footer.useCases,
        instagram: "Comptes Instagram multiples",
        facebook: "Comptes Facebook multiples",
        bulkEmail: "Campagnes d'e-mails en masse",
        socialAutomation: "Automatisation des réseaux sociaux",
      },
      resources: {
        ...en.footer.resources,
        blog: "Blog",
        guides: "Guides",
        apiDocs: "Documentation API",
        tutorials: "Tutoriels",
      },
      freeTools: {
        ...en.footer.freeTools,
        smsCalculator: "Calculateur de coût SMS",
        emailRoiCalculator: "Calculateur de ROI e-mail",
        engagementCalculator: "Calculateur d'engagement",
      },
      company: {
        ...en.footer.company,
        pricing: "Tarifs",
        about: "À propos",
        careers: "Carrières",
        contact: "Contact",
      },
      privacyPolicy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
    },
    contact: {
      ...en.contact,
      title: "Parlons de votre croissance !",
      subtitle:
        "Remplissez vos coordonnées et dites-moi comment je peux vous aider à créer un plan marketing gagnant.",
      name: "Votre nom",
      email: "Adresse e-mail",
      whatsapp: "Numéro WhatsApp",
      website: "URL du site web (facultatif)",
      servicePlaceholder: "Sélectionnez un service d'intérêt",
      goalsPlaceholder: "Parlez-moi de vos objectifs commerciaux...",
      submitBtn: "Obtenir mon appel stratégique gratuit",
      successTitle: "🚀 Message envoyé !",
      successSub: "Merci de nous avoir contactés. Nous vous répondrons sous peu.",
      backBtn: "Envoyer un autre message",
      sidebarTitle: "Contact",
      verify: "Vérifier",
      sending: "Envoi...",
      locationLabel: "Localisation",
      whatsappLabel: "WhatsApp",
      emailLabel: "E-mail",
      serviceOptions: [
        "Nouvelle fonctionnalité",
        "Stratégie SEO",
        "Publicités payantes (Meta/Google)",
        "Marketing de contenu",
        "Consultation individuelle",
      ],
    },
    socialPage: {
      ...en.socialPage,
      heroTitleMain: "Développez votre marque",
      heroTitleHighlight: "sur les réseaux sociaux",
      heroSubtitle:
        "Nous aidons les entreprises à transformer leur contenu en visibilité, en engagement et en vraies demandes — sans perdre de temps.",
      heroCta: "Commencer à grandir",
      featuredBadge: "INTÉGRATION À LA UNE",
      featuredHeading: "Libérez tout votre potentiel YouTube",
      featuredIntro:
        "Notre suite SocialFlow est profondément intégrée à YouTube pour vous aider à trouver les bons mots-clés, suivre votre concurrence et comprendre votre audience comme jamais auparavant.",
      card1Title: "Extracteur de tags",
      card1Desc:
        "Récupérez instantanément les tags cachés et les données SEO de n'importe quelle vidéo virale pour reproduire son succès.",
      card1Link: "Essayer l'extracteur de tags",
      card2Title: "Analyses approfondies",
      card2Desc:
        "Connectez votre chaîne pour voir les tendances de rétention, les pics d'engagement et les opportunités de croissance.",
      card2Link: "Voir le tableau de bord",
      ctaTitle: "Prêt à amplifier votre présence ?",
      ctaDesc:
        "Rejoignez des centaines de créateurs et d'entreprises qui utilisent SocialFlow pour automatiser leur croissance et se concentrer sur ce qu'ils font de mieux : créer.",
      ctaBtn: "Découvrir les tarifs et les offres",
    },
    automatePage: {
      ...en.automatePage,
      eyebrow: "Automatisation",
      heroTitle:
        "Automatisez votre entreprise. Évoluez sans recruter.",
      heroSubtitle:
        "Des systèmes d'automatisation intelligents qui gèrent les prospects, les relances, les ventes et la relation client — 24h/24 et 7j/7.",
      heroPrimaryBtn: "Réserver un audit gratuit",
      heroSecondaryBtn: "Voir comment ça marche",
      servicesHeading: "Ce que vous pouvez automatiser",
      servicesSubheading:
        "Choisissez les tâches répétitives dont vous voulez vous débarrasser — SocialFlow les fait tourner en arrière-plan.",
      services: [
        {
          title: "Automatisation de la capture de prospects",
          description: "Synchronisation des formulaires, intégration CRM, déclencheurs WhatsApp.",
        },
        {
          title: "Séquences e-mail",
          description: "Flux de bienvenue, panier abandonné, campagnes de nurturing.",
        },
        {
          title: "Automatisation des ventes",
          description: "Factures, rappels, confirmations de paiement.",
        },
        {
          title: "Gestion des clients",
          description: "Intégration, prise de rendez-vous, automatisation des retours.",
        },
      ],
      processHeading: "Comment ça marche",
      processSubheading:
        "Trois étapes simples du chaos manuel à une entreprise qui tourne toute seule.",
      steps: [
        {
          title: "Auditez votre flux de travail",
          description: "Identifiez les tâches manuelles et les opportunités d'automatisation.",
        },
        {
          title: "Construisez des systèmes intelligents",
          description: "Créez des tunnels, des déclencheurs et des intégrations CRM.",
        },
        {
          title: "Lancez et optimisez",
          description: "Surveillez, testez et améliorez les performances.",
        },
      ],
      ctaTitle: "Prêt à arrêter de tout faire manuellement ?",
      ctaSubtitle:
        "Laissez l'automatisation faire le travail pendant que vous vous concentrez sur la croissance.",
      ctaBtn: "Réserver un appel stratégique",
    },
    servicesIndexPage: {
      ...en.servicesIndexPage,
      badge: "Services de bout en bout",
      heading: "Une seule équipe pour tout votre stack",
      intro:
        "Les réseaux sociaux sont notre point de départ — mais nous construisons aussi tout ce qui se trouve derrière. IA, applications, sites web, intégrations, cloud et serveurs, le tout auprès d'un seul partenaire.",
      cta: "Démarrer une conversation",
      learnMore: "En savoir plus",
      ctaTitle: "Vous ne savez pas par où commencer ?",
      ctaSubtitle:
        "Dites-nous le résultat que vous voulez. Nous vous recommanderons le chemin le plus simple pour y arriver.",
      ctaBtn: "Réserver une consultation gratuite",
    },
    servicePage: {
      ...en.servicePage,
      notFoundTitle: "Service introuvable",
      notFoundText: "La page que vous recherchez n'existe pas.",
      backToAll: "Retour à tous les services",
      backHome: "Retour à l'accueil",
      home: "Accueil",
      allServices: "Tous les services",
      whatYouGet: "Ce que vous obtenez",
      popularUses: "Usages courants",
      talkToSpecialist: "Parler à un spécialiste",
      exploreMore: "Découvrir plus de ce que nous faisons",
      scopeTitle: "Définissons votre {service}",
      scopeSubtitle:
        "Dites-nous ce dont vous avez besoin. Nous tracerons le chemin le plus rapide et le plus sûr pour le mettre en ligne — gratuitement.",
      ctaBtn: "Réserver une consultation gratuite",
    },
    pricingPage: {
      ...en.pricingPage,
      heroTitle: "Choisissez votre voie de croissance",
      heroSubtitle: "Une tarification qui évolue avec vous",
      heroDesc:
        "Une tarification simple. Des livrables clairs. Conçue pour les créateurs, les indépendants et les entreprises en croissance.",
      mostPopular: "Le plus populaire",
      getStarted: "Commencer",
      plans: [
        {
          title: "Basique",
          price: "₹4 999 / mois",
          features: [
            "8 publications par mois",
            "Configuration Facebook / Instagram",
            "Intégration du bouton WhatsApp",
            "Configuration Google Business",
            "Conseils de base en image de marque",
          ],
        },
        {
          title: "Croissance",
          price: "₹9 999 / mois",
          features: [
            "15 publications + 4 Reels",
            "Optimisation Google Business",
            "Configuration de la capture de prospects",
            "Système de boost d'avis",
            "Configuration d'automatisation de base",
          ],
        },
        {
          title: "Pro",
          price: "₹19 999 / mois",
          features: [
            "Contenu quotidien",
            "Gestion des réponses",
            "Suivi avancé des demandes",
            "Optimisation du site web",
            "Système de relance commerciale",
          ],
        },
      ],
      addOnsTitle: "Options ponctuelles",
      addOns: [
        { name: "Site web 3 pages", price: "₹7 500" },
        { name: "Site web 5 pages", price: "₹12 000" },
        { name: "Page catalogue numérique", price: "₹5 000" },
        { name: "Configuration de réponse automatique WhatsApp", price: "₹2 500" },
        { name: "Boost d'avis Google", price: "₹3 500" },
        { name: "Application web progressive", price: "₹9 999" },
        { name: "Application Android", price: "₹25 000" },
      ],
      trust:
        "Aucun frais caché. Payez 50 % à l'avance et 50 % une fois votre projet en ligne.",
    },
    blogPage: {
      ...en.blogPage,
      seoTitle:
        "Blog SocialFlow | Réseaux sociaux, automatisation et croissance des entreprises",
      title: "Aperçus sur le marketing digital, les réseaux sociaux et l'automatisation",
      intro:
        "Explorez des guides experts sur la croissance sur les réseaux sociaux, les outils d'automatisation, les stratégies d'entreprise et la productivité. Apprenez à évoluer plus vite grâce à des systèmes plus intelligents.",
      searchPlaceholder: "Rechercher des articles...",
      featured: "À la une",
      categories: [
        { value: "All", label: "Tous" },
        { value: "Social Media", label: "Réseaux sociaux" },
        { value: "Automation", label: "Automatisation" },
        { value: "Growth", label: "Croissance" },
        { value: "Business", label: "Entreprise" },
        { value: "AI", label: "IA" },
      ],
    },
    dashboard: {
      ...en.dashboard,
      sidebarTitle: "Tableau de bord",
      soon: "Bientôt",
      welcome: "Bienvenue sur SocialFlow",
    },
    comingSoon: {
      ...en.comingSoon,
      featureNameDefault: "Cette fonctionnalité",
      description:
        "Nous travaillons dur pour vous apporter cette expérience. Rejoignez la liste d'attente pour être le premier informé de son lancement.",
      badge: "Bientôt disponible",
      titleTemplate: "{feature} arrive bientôt !",
      emailPlaceholder: "Saisissez votre e-mail",
      notifyBtn: "Me notifier",
      built: "Développé",
      inWaitlist: "Dans la liste d'attente",
    },
    userProfile: {
      ...en.userProfile,
      title: "Mon profil",
      personalInfo: "Informations personnelles",
      phone: "Téléphone",
      address: "Adresse",
      companyInfo: "Informations sur l'entreprise",
      companyName: "Nom de l'entreprise",
      companyAddress: "Adresse de l'entreprise",
      save: "Enregistrer",
      requiredAlert: "Le téléphone et le nom de l'entreprise sont obligatoires.",
      savedAlert: "Profil enregistré avec succès !",
    },
    pointsHistory: {
      ...en.pointsHistory,
      accessDenied: "Accès refusé",
      accessDeniedBody:
        "Veuillez vous connecter pour consulter vos points et l'historique des transactions.",
      transactionHistory: "Historique des transactions",
      sixMonths: "6 mois",
      all: "Tout",
      noTransactions: "Aucune transaction trouvée pour le moment.",
      invalidAmountAlert: "Veuillez saisir un montant positif valide.",
      manualTopUp: "Rechargement manuel",
      addedAlert: "{amount} points ajoutés avec succès !",
      addFailedAlert: "Échec de l'ajout des points. Veuillez réessayer.",
      currentBalance: "Solde actuel",
      socialPoints: "SocialPoints",
      valueApprox: "Valeur : env. ₹{amount} en services de plateforme",
      topUp: "Recharger",
      topUpBody:
        "Pendant notre phase bêta, vous pouvez recharger manuellement des points pour accéder aux outils premium.",
      add: "Ajouter",
      howToUse: "Comment utiliser les points",
      usageItems: [
        { title: "Vérification d'e-mail", cost: "5 pts / 100 e-mails" },
        { title: "Rapports YT avancés", cost: "10 pts / rapport" },
        { title: "Règles d'automatisation", cost: "2 pts / règle active" },
        { title: "Génération de modèles", cost: "1 pt / génération IA" },
      ],
      footerNote:
        "Les points n'expirent jamais. Vous pouvez gagner des points gratuits chaque jour en vérifiant votre profil ou en interagissant avec notre newsletter.",
      at: "à",
    },
    fieldServicePlannerPage: {
      ...en.fieldServicePlannerPage,
      heroTitleLead: "Maîtrisez vos",
      heroTitleHighlight: "opérations terrain",
      heroBody:
        "Rationalisez la planification, la répartition et les opérations de service sur site grâce à notre système de planification intelligent conçu pour éliminer les erreurs manuelles et booster la productivité.",
      getStarted: "Commencer gratuitement",
      bookDemo: "Réserver une démo",
      features: [
        {
          title: "Planification intelligente",
          description:
            "Attribuez automatiquement les interventions selon les disponibilités avec une détection intelligente des conflits.",
        },
        {
          title: "Répartition des techniciens",
          description:
            "Attribuez les interventions selon la localisation et les compétences avec optimisation des tournées.",
        },
        {
          title: "Suivi en direct",
          description:
            "Suivez les techniciens en temps réel et surveillez l'avancement des interventions grâce à des mises à jour instantanées.",
        },
        {
          title: "Gestion des interventions",
          description:
            "Créez, modifiez et gérez les demandes de service avec un historique numérique complet.",
        },
        {
          title: "Analyses et rapports",
          description:
            "Obtenez des informations approfondies sur les performances, la productivité et les taux d'achèvement.",
        },
        {
          title: "Flux de travail vérifié",
          description:
            "Des processus standardisés garantissent que chaque intervention respecte vos critères de qualité.",
        },
      ],
      processTitleLead: "Un flux de travail en trois étapes pour",
      processHighlight: "une efficacité maximale",
      steps: [
        {
          step: "01",
          title: "Réception intelligente",
          desc: "Les demandes entrantes sont automatiquement analysées et classées par priorité et par lieu.",
        },
        {
          step: "02",
          title: "Répartition par compétences",
          desc: "Notre algorithme associe le bon technicien à la bonne intervention selon son expertise.",
        },
        {
          step: "03",
          title: "Vérification en temps réel",
          desc: "Les photos sur site et les signatures numériques garantissent que chaque intervention est réalisée selon les normes.",
        },
      ],
      whyChooseTitle: "Pourquoi les entreprises nous choisissent",
      benefits: [
        "Réduisez les coûts opérationnels jusqu'à 25 %",
        "Améliorez les scores de satisfaction client",
        "Éliminez la paperasse et la saisie manuelle",
        "Développez vos opérations terrain en toute confiance",
      ],
      audienceTitle: "Parfait pour les équipes de service modernes",
      audiences: [
        "Support et réparation informatiques",
        "Entretien de la maison",
        "Services de conseil",
        "Logistique de livraison",
        "Santé et soins à domicile",
      ],
    },
    aboutPage: {
      ...en.aboutPage,
      heroTitleLead: "Combler le fossé entre",
      heroTitleHighlight: "Créativité et automatisation",
      heroSub:
        "SocialFlow a été fondée à New Delhi avec une seule mission : remplacer les tâtonnements manuels sur les réseaux sociaux par une précision algorithmique.",
      whyTitle: "Pourquoi nous avons créé SocialFlow",
      whyP1:
        "Le paysage numérique évolue trop vite pour une gestion manuelle traditionnelle. Nous avons constaté que les créateurs et les entreprises consacraient 80 % de leur temps à des tâches techniques — trouver des tags, optimiser le SEO et suivre les indicateurs — et seulement 20 % à leur véritable métier.",
      whyP2Before: "Nous avons créé notre ensemble d'outils propriétaire, dont notre",
      whyP2Strong: "Extracteur de tags YouTube",
      whyP2After:
        ", pour inverser ce rapport. Nous nous occupons des données ; vous vous occupez de la vision.",
      dataDrivenGrowth: "Croissance pilotée par les données",
      methodologyTitle: "Notre méthodologie en 3 piliers",
      pillars: [
        {
          title: "L'audit approfondi",
          text: "Nous ne devinons pas. Nous utilisons l'analyse des métadonnées pour comprendre pourquoi vos concurrents gagnent et où se trouvent les « voies libres » pour votre marque.",
        },
        {
          title: "SEO algorithmique",
          text: "Chaque publication et chaque vidéo est optimisée à l'aide de nos outils sur mesure pour que les algorithmes des plateformes travaillent pour vous, et non contre vous.",
        },
        {
          title: "Supervision humaine",
          text: "La technologie est notre plateforme, mais les humains en sont les pilotes. Chaque analyse automatisée est validée par notre équipe de stratégie basée à Delhi.",
        },
      ],
      ctaTitle: "Prêt à automatiser votre croissance ?",
      ctaButton: "Devenez notre partenaire",
    },
    // --- YOUTUBE INSIGHTS DATA (FR) ---
    youtubeFacts: youtubeFacts.fr,
  },
};

export type LanguageCode = keyof typeof translations;

/**
 * Languages offered in the UI. Add a new entry here (plus a matching block in
 * `translations`) to introduce a language. Keep this in sync with
 * `translations`.
 */
export const LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: "en", label: "En" },
  { code: "hi", label: "हिंदी" },
  { code: "fr", label: "Français" },
];

/**
 * Resolve a value for the requested language with an English fallback.
 *
 * Use this for partial per-language maps (e.g. small inline content objects)
 * so that adding a new language never breaks existing components — anything
 * not yet translated simply shows English.
 */
export function pickLang<T>(
  map: Partial<Record<LanguageCode, T>>,
  lang: LanguageCode
): T {
  return (map[lang] ?? map.en) as T;
}
